import React from 'react';
import {connect} from 'react-redux';
import {
    closeLargeSnippetsPopup,
    updateEditLargeSnippetsSection,
    openPagePicker,
    closePagePicker,
} from '../../actions';

import LargeSnippetsSectionEditPopup from './large_snippets_section_edit';
import {clearPageSearchFilter} from '../../../page-picker/actions';
import {onSearchPages} from '../../../page-picker/thunks';
import {showErrMsgPopup} from '../../../../components/helpers/helpers';
import {
    pickLargeSnippetPage,
    updateSnippetImageInLargeSnippetsPopup,
    deleteSnippetImageInLargeSnippetsPopup,
    updateCroppedSnippetImageInLargeSnippetsPopup,
    updateThumbCroppedSnippetImageInLargeSnippetsPopup,
    updateSnippetImageMetaInLargeSnippetsPopup,
    updateLogoImageInLargeSnippetsPopup,
    deleteLogoImageInLargeSnippetsPopup,
    updateCroppedLogoImageInLargeSnippetsPopup,
    updateThumbCroppedLogoImageInLargeSnippetsPopup,
    updateLogoImageMetaInLargeSnippetsPopup,
} from '../../sections/actions';
import {fetchImageRatios} from '../../../images/thunks';

class LargeSnippetsPopup extends React.Component {
    componentWillUpdate(nextProps) {
        if (
            nextProps.largeSnippetsSectionPopupOpen === true &&
            this.props.largeSnippetsSectionPopupOpen === false
        ) {
            this.props.fetchImageRatios();
        }
    }

    render() {
        return (
            <LargeSnippetsSectionEditPopup
                open={this.props.largeSnippetsSectionPopupOpen}
                siteId={this.props.siteId}
                pageId={this.props.pageId}
                sectionId={this.props.largeSnippetsSectionId}
                largeSnippets={this.props.largeSnippetsSectionLargeSnippets}
                sectionPagePickerPopupOpen={
                    this.props.sectionPagePickerPopupOpen
                }
                pageSearchCriteria={this.props.pageSearchCriteria}
                allPagesBySearchCriteria={this.props.allPagesBySearchCriteria}
                onSearchPages={this.props.onSearchPages}
                onPickSectionPage={this.props.onPickSectionPage}
                openPagePicker={() => this.props.openPagePicker()}
                closePagePicker={() => {
                    this.props.closePagePicker();
                    this.props.clearPageSearchFilter();
                }}
                imageRatios={this.props.imageRatios.large_snippets}
                onUpdateSnippetImageField={(index, images) =>
                    this.props.updateSnippetImageSectionFields(index, images[0])
                }
                onDeleteSnippetImageField={(image, index) =>
                    this.props.deleteSnippetImageFromSectionField(image, index)
                }
                onCropSnippetImage={(
                    index,
                    image,
                    imageUrlBlob,
                    imageBlobObject
                ) => {
                    this.props.updateCroppedSnippetImage(
                        index,
                        image,
                        imageUrlBlob,
                        imageBlobObject
                    );
                }}
                onCropThumbSnippetImage={(
                    index,
                    image,
                    imageUrlBlob,
                    imageBlobObject
                ) => {
                    this.props.updateThumbCroppedSnippetImage(
                        index,
                        image,
                        imageUrlBlob,
                        imageBlobObject
                    );
                }}
                onSnippetImageMetaUpdate={(index, imageMeta) => {
                    this.props.updateSnippetImageMeta(index, imageMeta);
                }}
                onUpdateLogoImageField={(index, images) =>
                    this.props.updateLogoImageSectionFields(index, images[0])
                }
                onDeleteLogoImageField={(image, index) =>
                    this.props.deleteLogoImageFromSectionField(image, index)
                }
                onCropLogoImage={(
                    index,
                    image,
                    imageUrlBlob,
                    imageBlobObject
                ) => {
                    this.props.updateCroppedLogoImage(
                        index,
                        image,
                        imageUrlBlob,
                        imageBlobObject
                    );
                }}
                onCropThumbLogoImage={(
                    index,
                    image,
                    imageUrlBlob,
                    imageBlobObject
                ) => {
                    this.props.updateThumbCroppedLogoImage(
                        index,
                        image,
                        imageUrlBlob,
                        imageBlobObject
                    );
                }}
                onLogoImageMetaUpdate={(index, imageMeta) => {
                    this.props.updateLogoImageMeta(index, imageMeta);
                }}
                onHandleSubmit={() => {
                    // Add crop alert on DONE only for the snippet background image, not for the logo
                    let imageHasCrop = this.props.sectionData.large_snippets.find(
                        (snippet) =>
                            snippet.snippet_image &&
                            snippet.snippet_image.new &&
                            !snippet.snippet_image.deleted &&
                            snippet.snippet_image.croppedImage === null
                    );
                    imageHasCrop
                        ? showErrMsgPopup(
                              'Cropping the Snippet Background Image is mandatory! Please click on it in order to CROP it.'
                          )
                        : this.props.updateLargeSnippetsSectionContents(
                              this.props.pageId,
                              this.props.largeSnippetsSectionId,
                              this.props.sectionData
                          );
                }}
                onHandleClose={() => this.props.closeLargeSnippetsPopup()}
            />
        );
    }
}

const mapStateToProps = (state, props) => ({
    sectionData: state.pageBuilderSectionPopup.data,
    largeSnippetsSectionPopupOpen:
        state.pageBuilder.largeSnippetsSectionPopup.open,
    largeSnippetsSectionId: state.pageBuilderSectionPopup.sectionId,
    largeSnippetsSectionLargeSnippets:
        state.pageBuilderSectionPopup.data.large_snippets,
    sectionPagePickerPopupOpen:
        state.pageBuilder.sectionPagePickerPopup.open,
    clearPageSearchFilter: clearPageSearchFilter,
    pageSearchCriteria: state.pagePicker.pageSearchCriteria,
    allPagesBySearchCriteria: state.pagePicker.allPagesBySearchCriteria,
    siteId: state.pageBuilder.pages[props.pageId].meta.site_id,
    imageRatios: state.images.ratios,
});

export default connect(
    mapStateToProps,
    {
        closeLargeSnippetsPopup: closeLargeSnippetsPopup,
        updateLargeSnippetsSectionContents: updateEditLargeSnippetsSection,
        openPagePicker,
        closePagePicker,
        onSearchPages: onSearchPages,
        onPickSectionPage: pickLargeSnippetPage,
        fetchImageRatios,

        updateSnippetImageSectionFields: updateSnippetImageInLargeSnippetsPopup,
        deleteSnippetImageFromSectionField: deleteSnippetImageInLargeSnippetsPopup,
        updateCroppedSnippetImage: updateCroppedSnippetImageInLargeSnippetsPopup,
        updateThumbCroppedSnippetImage: updateThumbCroppedSnippetImageInLargeSnippetsPopup,
        updateSnippetImageMeta: updateSnippetImageMetaInLargeSnippetsPopup,

        updateLogoImageSectionFields: updateLogoImageInLargeSnippetsPopup,
        deleteLogoImageFromSectionField: deleteLogoImageInLargeSnippetsPopup,
        updateCroppedLogoImage: updateCroppedLogoImageInLargeSnippetsPopup,
        updateThumbCroppedLogoImage: updateThumbCroppedLogoImageInLargeSnippetsPopup,
        updateLogoImageMeta: updateLogoImageMetaInLargeSnippetsPopup,
    }
)(LargeSnippetsPopup);



// WEBPACK FOOTER //
// ./src/containers/builder/form/popups/large_snippets_popup.js